import type { ExperienceRating } from "./types";

export const isExperienceRating = (
  value: string | null | undefined
): value is ExperienceRating =>
  value === "sad" || value === "neutral" || value === "happy";

export const toTitleCase = (value: string) =>
  value
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const formatValue = (value?: string | null, fallback = "Not provided") =>
  value ? toTitleCase(value) : fallback;

export const formatList = (
  values?: (string | null | undefined)[] | null,
  fallback: string[] = []
) => {
  const cleaned = (values ?? []).filter(Boolean) as string[];
  if (cleaned.length) {
    return cleaned.map((item) => toTitleCase(item));
  }
  return fallback;
};

export const parseCountValue = (value: string, fallback = 0) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? fallback : parsed;
};

export const normalizeSingleSentence = (value: string) => {
  const cleaned = value.replace(/\r?\n/g, " ").replace(/\s{2,}/g, " ");
  const match = cleaned.match(/[.!?]/);
  if (match) {
    const idx = cleaned.indexOf(match[0]);
    return cleaned.slice(0, idx + 1).trimStart();
  }
  return cleaned.trimStart();
};

const formatLocalDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getTomorrowDate = () => {
  const now = new Date();
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return formatLocalDate(tomorrow);
};

export const ensureFutureDate = (value?: string | null) => {
  if (!value) return value ?? null;
  const normalized = value.slice(0, 10);
  const minDate = getTomorrowDate();
  return normalized < minDate ? minDate : normalized;
};
